export default "__VITE_ASSET__Gh$qnIsQ__"